import { IS_CLIENT, IS_ANDROID, IS_IOS } from '@repo/common-utils';

import { useWorkingPlatform } from './use-working-platform';

export const useWindowOpen = () => {
  const { workingPlatform, workingPlatformType } = useWorkingPlatform();

  const openWindow = (link: string, target?: string) => {
    if (!IS_CLIENT) return;

    if (workingPlatform === 'kbank') {
      if (IS_ANDROID) {
        window?.kbw?.kbankopenbrowser?.(JSON.stringify({ url: link }));
      } else if (IS_IOS) {
        window?.webkit?.messageHandlers?.kbankopenbrowser?.postMessage(JSON.stringify({ url: link }));
      }
      return;
    }

    window.open(link, target ?? (workingPlatformType === 'web' ? '_blank' : '_system'));
  };

  return {
    openWindow
  };
};
